import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import CloudOffIcon from '@mui/icons-material/CloudOff';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import RefreshIcon from '@mui/icons-material/Refresh';
import { layout, radius } from '../../themes/smartinventoryTheme';

// scope="page"   a failed PRIMARY request — replaces the content, a retry
//                button, and a selectable request line for support tickets.
// scope="strip"  a failed SECONDARY request — degrades one strip, the rest
//                of the page stays usable.
const ErrorState = ({ scope = 'page', title, description, request, onRetry, retryLabel }) => {
  if (scope === 'strip') {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          p: 2,
          borderRadius: `${radius.lg}px`,
          bgcolor: 'error.light',
          border: '1px solid',
          borderColor: 'error.main',
        }}
      >
        <ErrorOutlineIcon color="error" fontSize="small" />
        <Typography variant="body2" color="text.secondary" sx={{ flex: 1 }}>{description}</Typography>
        {onRetry && (
          <Typography
            component="button"
            onClick={onRetry}
            variant="body2"
            fontWeight={600}
            sx={{
              color: 'primary.main',
              cursor: 'pointer',
              bgcolor: 'transparent',
              border: 'none',
              font: 'inherit',
              whiteSpace: 'nowrap',
            }}
          >
            {retryLabel}
          </Typography>
        )}
      </Box>
    );
  }

  return (
    <Box sx={{ textAlign: 'center', py: 5, px: 3 }}>
      <Box
        sx={{
          width: layout.stateIconSize,
          height: layout.stateIconSize,
          borderRadius: '50%',
          bgcolor: 'error.light',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 1.5,
        }}
      >
        <CloudOffIcon color="error" />
      </Box>
      <Typography variant="subtitle1">{title}</Typography>
      {description && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, maxWidth: 380, mx: 'auto' }}>
          {description}
        </Typography>
      )}
      {onRetry && (
        <Box sx={{ mt: 2 }}>
          <Button variant="contained" startIcon={<RefreshIcon />} onClick={onRetry}>
            {retryLabel}
          </Button>
        </Box>
      )}
      {request && (
        <Typography
          component="div"
          variant="caption"
          color="text.secondary"
          sx={{ mt: 1.5, fontFamily: 'ui-monospace, monospace', userSelect: 'all' }}
        >
          {request}
        </Typography>
      )}
    </Box>
  );
};

export default ErrorState;
